import React from 'react';
import { Navigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { systemCode, urls } from '..';
import { usePrematchData } from './PrematchDataProvider';
import ScrollerContainer from '../common/ScrollerContainer';
import SportsMenuWrapper from '../common/SportsMenuWrapper';
import TopMenu from '../common/TopMenu';
import TournamentsMenu from '../common/TournamentsMenu';
import DateSelectionNavbar from './DateSelectionNavbar';
import PrematchLinks from './PrematchLinks';
import { getLabel } from '../data/labels';
import BannersCarousel from '../common/banners/BannersCarousel';
import StickyHeader from '../common/StickyHeader';
import TournamentsMenuDropdown from '../common/TournamentsMenuDropdown';
import { useUserSettings } from '../common/UserSettingsProvider';
import { removeMultipleSlashes } from '../data/sport-utils';
import LiveTv from '../common/live-tv/LiveTv';
import DateSelectionNavbarAlt from './DateSelectionNavbarAlt';
import { getConfiguration } from '../data/utils/configuration';
import HighlightedTournaments from './HighlightedTournaments';
import SwiperCardsWh from '../common/banners/SwiperCardsWh';

export default function Prematch() {
    const params = useParams();
    const prematchData = usePrematchData();
    const userSettings = useUserSettings();
    const conf = getConfiguration();

    let sport = null;
    if (params.sportId != null) {
        const isNumber = !isNaN(Number(params.sportId));
        if (!isNumber) {
            return <Navigate to={removeMultipleSlashes(`${urls.base}/${urls.notFound}`)} />;
        }
        sport = prematchData.sportById[params.sportId];
    } else {
        sport = prematchData.sport.find(s => s.id < 8000);
    }

    if (sport == null) {
        sport = prematchData.sport[0];
    }

    return (
        <>
            <StickyHeader>
                <TopMenu title={getLabel('menu.prematch')} />
                <SportsMenuWrapper sports={prematchData.sport}
                    selected={sport}
                    showBackButton={false}
                    showEventsCount={true} />
                {systemCode === 'SUREBET' && 
                <div className='highlighted__wrapper'>
                <HighlightedTournaments sportId={sport.categories[0].sportRef} categories={sport.categories} />
                <PrematchLinks />
                </div>}
                {conf.iwh ? <DateSelectionNavbarAlt /> : <DateSelectionNavbar />}
                {!conf.bbc?.en && <PrematchLinks />}
            </StickyHeader>
            <ScrollerContainer>
                {userSettings.showBanners &&
                    <BannersCarousel />
                }
                {!conf.iwh &&
                    <SwiperCardsWh />
                }
                <LiveTv container="landing" />

                {userSettings.showCollapsedCategories ?
                    <TournamentsMenuDropdown categories={sport.categories} />
                    :
                    <TournamentsMenu categories={sport.categories} />
                }
            </ScrollerContainer>
        </>
    );
}
